import React, { useState, useRef } from "react";
import { BiSolidReport } from "react-icons/bi";
import "./ReportProvComercializadorAdmin.css";
import axios from "axios";
import Swal from "sweetalert2";

const ReportProvComercializadorAdmin = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");
  const downloadLinkRef = useRef(null);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectYear(event.target.value);
  };
  const monthString = selectedMonth;
  const year = selectYear;
  // Construir la URL para la descarga del informe
  const url = `${process.env.REACT_APP_DOWNLOAD_SALES_XLSX_ADMIN_SUPPLIER}?month=${monthString}&year=${year}`;

  const handleDownloadClick = () => {
    // Realizar una solicitud GET para verificar si el recurso existe
    axios
      .get(url)
      .then(() => {
        // Si la respuesta es exitosa, activar la descarga a través del enlace oculto
        downloadLinkRef.current.click();
      })
      .catch((error) => {
        // Si hay un error (por ejemplo, 404), mostrar la alerta
        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "Datos no encontrados",
            text: "No hay ventas agregadas en ese mes o año",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se pudo descargar el archivo.",
          });
        }
      });
  };

  return (
    <div className="boxreportallprov">
      <div className="boxreport">
        <div className="ReportsProv">
          <div className="displayboxReport-prov">
            <div className="iconReportbox-prov">
              <BiSolidReport className="iconreport-prov" />
            </div>
            <div className="widtallreport-amebo">
              <div className="widtallreport-prov">
                <select
                  className="montinputreport-prov"
                  value={selectYear}
                  onChange={handleYearChange}
                >
                  <option value="">Selecciona un año</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                  <option value="2031">2031</option>
                  <option value="2032">2032</option>
                  <option value="2033">2033</option>
                  <option value="2034">2034</option>
                </select>
              </div>
              <div className="boxinputreport-prov">
                <select
                  className="montinputreport-prov"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  <option value="">Selecciona un mes</option>
                  <option value="Enero">Enero</option>
                  <option value="Febrero">Febrero</option>
                  <option value="Marzo">Marzo</option>
                  <option value="Abril">Abril</option>
                  <option value="Mayo">Mayo</option>
                  <option value="Junio">Junio</option>
                  <option value="Julio">Julio</option>
                  <option value="Agosto">Agosto</option>
                  <option value="Septiembre">Septiembre</option>
                  <option value="Octubre">Octubre</option>
                  <option value="Noviembre">Noviembre</option>
                  <option value="Diciembre">Diciembre</option>
                </select>
              </div>
              <div className="boxinputbuttonreport-amebo">
                <a
                  ref={downloadLinkRef}
                  href={url}
                  download
                  style={{ display: "none" }}
                >
                  Descargar
                </a>
                <button
                  className="buttonreport-amebo"
                  onClick={handleDownloadClick}
                >
                  Descargar Archivo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportProvComercializadorAdmin;
